import React from 'react';

import { IconBaseProps } from 'src/ui-models/Icon';
import IconBase from '../icon-base/IconBase';

const StraightenIcon: React.FC<IconBaseProps> = ({ width = 24, height = 24, color = 'currentColor' }) => {
  return (
    <IconBase color={color} width={width} height={height}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 0H20C21.1 0 22 0.9 22 2V10C22 11.1 21.1 12 20 12H2C0.9 12 0 11.1 0 10V2C0 0.9 0.9 0 2 0ZM3 10H19C19.55 10 20 9.55 20 9V3C20 2.45 19.55 2 19 2H18V5C18 5.55 17.55 6 17 6C16.45 6 16 5.55 16 5V2H14V5C14 5.55 13.55 6 13 6C12.45 6 12 5.55 12 5V2H10V5C10 5.55 9.55 6 9 6C8.45 6 8 5.55 8 5V2H6V5C6 5.55 5.55 6 5 6C4.45 6 4 5.55 4 5V2H3C2.45 2 2 2.45 2 3V9C2 9.55 2.45 10 3 10Z"
        fill={color}
      />
    </IconBase>
  );
};

export default StraightenIcon;
